var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 76,
    viewBox: "0 0 61 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7374 1.13379C32.3715 -0.258843 30.1684 -0.38406 28.6532 0.84413C24.2763 4.39081 20.8215 6.61634 17.1106 8.18099C13.3848 9.75196 9.20222 10.7405 3.2574 11.5734C1.38943 11.8352 0 13.4309 0 15.3148V42.7171C0 48.3805 2.47474 53.7703 6.78503 57.4189L26.0969 73.7696C28.9756 76.2058 33.1911 76.1424 35.9956 73.6247L54.15 57.3275C58.2097 53.6827 60.5197 48.4582 60.5197 42.9869V16.2387C60.5197 14.4565 59.2729 12.9171 57.5284 12.5447C50.8584 11.1198 46.4486 9.77404 42.9609 8.06951C39.5465 6.40109 36.8489 4.30524 33.7366 1.13482L33.7374 1.13379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/security-icon.e0b830114243faa1fa00661c0b9cc595.svg";
export { ForwardRef as ReactComponent };